module.exports = __webpack_public_path__ + "static/media/dpi.9d7ef9c9.svg";